<template>
    <v-menu v-if="shouldDisplayExtraInfo" open-on-click offset-y offset-x>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="info-icon" :size="size">mdi-information-outline</v-icon>
        </template>
        <v-card class="info-tooltip">
            <v-list dense>
                <v-list-item v-for="(value, key) in filteredExtraInfo" :key="key" >
                    <v-list-item-content>
                        <v-list-item-title>{{ key }}</v-list-item-title>
                        <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>
<script>
    export default {
        props: {
            extraInfo: {
                type: Object,
                default: () => { return null }
            },
            size: {
                type: Number,
                default: () => { return 26 }
            }
        },
        computed: {
            shouldDisplayExtraInfo() {
                return this.extraInfo && (Object.keys(this.extraInfo).length > 1 || (Object.keys(this.extraInfo).length === 1 && !this.extraInfo.malfunction))
            },
            filteredExtraInfo() {
                const excluded = ['malfunction']
                return Object.fromEntries(
                    Object.entries(this.extraInfo).filter(([key]) => !excluded.includes(key))
                )
            }
        }
    }
</script>
<style scoped>

.info-icon:hover {
    color: orange !important;
}

.info-icon {
    color: #0047AB;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.info-tooltip {
    overflow-y: auto;
    scrollbar-width: thin !important;
    scrollbar-color: #888 transparent !important;
    max-height: 400px;
}
</style>
